/**
 * Глобальная структура подсказок в проекте
 */
const state = {
  // содержание подсказок
  hints: {
    detailing: `<div>Здесь вы видите детализацию всех отправленных sms по вашим
      хот-спотам, рекламным или смс авторизации, в рамках и сверх тарифа.
      Чтобы увеличить лимит смс, подключите дополнительный пакет смс.</div>`,

    statisticsGeneral: `<div>Здесь вы видите статистику авторизаций по выбранному хот-споту.</div>
      <div class="py-2">Вы можете:
        <ul>
          <li>
            посмотреть детализацию <b>c номерами телефонов</b> - под графиком,
          </li>
          <li>выгрузить данные в Excel/Csv,</li>
          <li>
            выбрать интересующие номера телефонов и отправить <b>рекламные смс</b>,
            </li>
          <li>
          сохранить выбранные настройки как шаблон. Отчет будет доступен в
          любое время в разделе «Мои шаблоны»
          </li>
        </ul>
      </div>`,

    statisticsVisits: `<div>Здесь вы видите статистику по частым и редким авторизациям на
      вашем хот-споте. Вы можете сформировать список гостей, которые давно не авторизовывались
      в вашей Wi-Fi сети (день/неделю/месяц/квартал), т.е. с высокой долей вероятности давно
      не заходили в ваше заведение, и попытаться их вернуть с помощью рекламной смс-рассылки.
      <br>Также вы можете выгрузить номера телефонов и использовать их для таргета интернет-рекламы.</div>`,

    statisticsGone: `<div>Здесь вы видите список телефонов тех гостей, которые не проходили авторизацию
      более 30 дней/1 квартала, т.е. с высокой долей вероятностью давно не посещали ваше заведение и
      ушли к конкуренту. Попробуйте их вернуть с помощью рекламной смс-рассылки или скачайте список
      номеров телефонов для таргета интернет-рекламы.</div>`,

    theme: `<div>Настройте дизайн хот-спота в вашем фирменном стиле. Создайте тему авторизации и примените
      ее к одному или нескольким хот-спотам, с альтернативным текстом на английском языке. Например вы можете
      привязать тему к событию (например, к Новому году).</div>`,

    themeSettings: `Укажите ссылку на ресурс (сайт, лендинг, соц.сети), на который гость
      автоматически будет направлен после авторизации.`,

    themeSettingsEng: `Этот текст увидят гости с не-российскими номерами телефонов, успешно
      прошедшие авторизацию (например, «Welcome to Russia!)`,

    advertising: `<div>Здесь вы видите статистику по всем вашим рекламным кампаниям.</div>
      <div class="py-2">Рекламная кампания – это возможность показать пользователю баннер после успешной
        авторизации в Wi-Fi сети. Доли гостей, перешедших по ссылке в баннере и закрывших баннер, будут
        отражены в статистике.</div>
      <div class="pb-2">Расскажите гостям о новом меню или акции, планируйте сезонные распродажи на год
        вперед, используйте разные баннеры для разных хот-спотов.</div>
      <div>Если гость пропускает рекламу, он будет перенаправлен по ссылке, указанной в Теме авторизации
        данного хот-спота.</div>`,

    advertisingSettings: `<div>Этот баннер гости увидят после авторизации. Расскажите посетителям о новом
      меню или акции.</div>
      <div class="py-2">Вы можете:
        <ul>
          <li>запланировать неограниченное количество рекламных кампаний,</li>
          <li>создать рекламную кампанию для иностранных гостей,</li>
          <li>подключить одну рекламную кампанию к одному или нескольким хот-спотам,</li>
          <li>выбрать, кому показывать баннер – новым гостям или тем, кто пришел повторно (т.е.
            повторно появился в Wi-Fi сети, но не ранее, чем через 12 часов после предыдущей авторизации).</li>
        </ul>
      </div>`,

    advertisingRange: `По умолчанию реклама будет отображаться для всех с интервалом в 12 часов.`,

    polls: `<div>Здесь вы видите статистику по всем вашим опросам.</div>
      <div class="py-2">Опрос – это возможность получить обратную связь от клиента посредством анкеты или оценки.
        Опрос появится после успешной авторизации, до рекламы (если реклама привязана к хот-споту).</div>
      <div class="pb-2">Узнайте, что думают ваши клиенты о новом меню или продукте, следите за уровнем
        обслуживания в разных точках вашей сети.</div>
      <div>Если гость пропускает опрос, он будет перенаправлен на рекламную кампанию. Если рекламная кампания
        не подключена или гость ее пропускает – то на ссылку, указанную в Теме авторизации данного хот-спота.</div>`,

    pollsSettings: `<div>Этот опрос гости увидят после успешной авторизации в Wi-Fi сети. Узнайте, что думают
      ваши клиенты о новом меню или продукте, следите за уровнем обслуживания в разных точках вашей сети.</div>
      <div class="py-2">
        Вы можете:
          <ul>
            <li>запланировать неограниченное количество опросов,</li>
            <li>подключить один опрос к одному или нескольким хот-спотам,</li>
            <li>выбрать, кому показывать опрос – новым гостям или тем, кто пришел повторно (т.е. повторно появился
              в сети, но не ранее, чем через 12 часов после предыдущей авторизации).</li>
          </ul>
      </div>`,

    smsMailing: `<div>Отправьте рекламные смс по выборочным номерам или всем номерам за
      указанный период. Количество номеров рассчитывается автоматически с
      учетом того, что в указанный период один клиент мог пройти авторизацию
      минимум дважды.</div>`,

    hotspotTheme: `Создайте тему авторизации в соответствующем разделе и прикрепите
      ее к хот-споту. Вы можете создать несколько тем и менять их при
      необходимости.`,

    hotspotPolls: `Создайте опрос, который появится после успешной авторизации и до
      рекламы (если она привязана к хот-споту).`,

    hotspotAdv: `Создайте рекламный баннер, который будет показан пользователю
      после успешной авторизации в wi-fi сети.`,

    changeTitleHotspot: `Присвойте хот-споту заголовок, чтобы было проще найти, если у Вас
      несколько хот-спотов.`,

    hotspotAddNew: `Отправьте заявку вашему персональному менеджеру на просчет нового
      хот-спота`
  },
  // состояние отображения подсказок
  hintActive: {
    detailing: true,
    statisticsGeneral: true,
    statisticsVisits: true,
    statisticsGone: true,
    theme: true,
    themeSettings: true,
    themeSettingsEng: true,
    advertising: true,
    advertisingSettings: true,
    advertisingRange: true,
    polls: true,
    pollsSettings: true,
    smsMailing: true,
    hotspotTheme: true,
    hotspotPolls: true,
    hotspotAdv: true,
    changeTitleHotspot: true,
    hotspotAddNew: true
  }
};

const mutations = {
  // переключает состояния отображения подсказок
  TOGGLE_HINT_IS_ACTIVE(state, data) {
    if (state.hintActive[data] === true) state.hintActive[data] = false;
    else state.hintActive[data] = true;
  }
};

const actions = {
  // показывает/скрывает подсказку
  toggleHint({ commit }, params) {
    commit("TOGGLE_HINT_IS_ACTIVE", params);
  }
};

const getters = {
  /**
   * Возвращает параметры подсказки
   */
  getHint: state => name => {
    return { hint: state.hints[name], hintActive: state.hintActive[name] };
  }
};

export default {
  state,
  mutations,
  actions,
  getters
};
